import React from "react";
import { Controller, useFieldArray, useFormContext } from "react-hook-form";
import CustomInput from "../../../Common/CustomInput";
import {
    generateNewChoice,
    multipleChoiceSingleShuffleOptions,
} from "../../../../utils/surveys";
import CustomSelect from "../../../Common/CustomSelect";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import { ErrorMessage } from "@hookform/error-message";

const GridChoiceQuestionItem = ({ questionName, questionIndex }) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const {
        fields: choicesArr,
        append: appendChoice,
        remove: removeChoice,
        update: updateChoice,
    } = useFieldArray({
        control,
        name: `${questionName}.choices`,
    });

    const {
        fields: rowsArr,
        append: appendRow,
        remove: removeRow,
        update: updateRow,
    } = useFieldArray({
        control,
        name: `${questionName}.rows`,
    });

    const changeChoiceHandler = (e, choiceIndex) => {
        updateChoice(choiceIndex, {
            ...choicesArr[choiceIndex],
            label: e.target.value,
        });
    };

    const addNewChoiceHandler = () => {
        appendChoice(generateNewChoice());
    };

    const deleteChoiceHandler = (choiceIndex) => {
        removeChoice(choiceIndex);
    };

    const changeRowHandler = (e, rowIndex) => {
        updateRow(rowIndex, {
            ...choicesArr[rowIndex],
            label: e.target.value,
        });
    };

    const addNewRowHandler = () => {
        appendRow(generateNewChoice());
    };

    const deleteRowHandler = (rowIndex) => {
        removeRow(rowIndex);
    };

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "20px",
            }}
        >
            {/* <Controller
                control={control}
                name={`${questionName}.shuffleOption`}
                render={({ field }) => (
                    <CustomSelect
                        style={{ width: "100%" }}
                        errors={errors}
                        label="Shuffle Options"
                        valueKey="value"
                        labelKey="label"
                        options={multipleChoiceSingleShuffleOptions}
                        {...field}
                    />
                )}
            /> */}
            <Typography.Title level={5} style={{ marginBottom: "-10px" }}>
                Rows:
            </Typography.Title>
            {errors[`pages`]?.questions?.[questionIndex]?.rows?.message && (
                <div style={{ textAlign: "center" }}>
                    <ErrorMessage
                        errors={errors}
                        name={`questions[${questionIndex}].rows`}
                        render={(data) => (
                            <Typography.Text type="danger">
                                * {data?.message}
                            </Typography.Text>
                        )}
                    />
                </div>
            )}
            {rowsArr.map((row, index) => (
                <div
                    key={row.id}
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                >
                    <Controller
                        control={control}
                        name={`${questionName}.rows[${index}].label`}
                        render={({ field }) => (
                            <CustomInput
                                errors={errors}
                                divProps={{ style: { width: "100%" } }}
                                onChange={(e) => changeRowHandler(e, index)}
                                {...field}
                            />
                        )}
                    />
                    <div
                        style={{
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div>
                            <PlusOutlined onClick={addNewRowHandler} />
                        </div>
                        {rowsArr.length > 1 && (
                            <div>
                                <DeleteFilled
                                    onClick={() => deleteRowHandler(index)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            ))}
            <Typography.Title level={5} style={{ marginBottom: "-10px" }}>
                Choices:
            </Typography.Title>
            {errors[`pages`]?.questions?.[questionIndex]?.choices?.message && (
                <div style={{ textAlign: "center" }}>
                    <ErrorMessage
                        errors={errors}
                        name={`questions[${questionIndex}].choices`}
                        render={(data) => (
                            <Typography.Text type="danger">
                                * {data?.message}
                            </Typography.Text>
                        )}
                    />
                </div>
            )}
            {choicesArr.map((choice, index) => (
                <div
                    key={choice.id}
                    style={{
                        display: "flex",
                        gap: "20px",
                        alignItems: "center",
                    }}
                >
                    <Controller
                        control={control}
                        name={`${questionName}.choices[${index}].label`}
                        render={({ field }) => (
                            <CustomInput
                                errors={errors}
                                divProps={{ style: { width: "100%" } }}
                                onChange={(e) => changeChoiceHandler(e, index)}
                                {...field}
                            />
                        )}
                    />
                    <div
                        style={{
                            display: "flex",
                            gap: "20px",
                        }}
                    >
                        <div>
                            <PlusOutlined onClick={addNewChoiceHandler} />
                        </div>
                        {choicesArr.length > 1 && (
                            <div>
                                <DeleteFilled
                                    onClick={() => deleteChoiceHandler(index)}
                                />
                            </div>
                        )}
                    </div>
                </div>
            ))}
        </div>
    );
};

export default GridChoiceQuestionItem;
